import { AreaEnum } from '../generated/backend-enums.js';
export { AreaEnum };
export const AreaLabelsMap = {
    [AreaEnum.ATENDIMENTO]: 'Atendimento',
    [AreaEnum.TECNOLOGIA]: 'Tecnologia',
    [AreaEnum.PRE_PRODUCAO]: 'Pré-Produção',
    [AreaEnum.COMPRAS]: 'Compras',
    [AreaEnum.CRIACAO]: 'Criação',
    [AreaEnum.PLANEJAMENTO]: 'Planejamento',
    [AreaEnum.PRODUCAO_FINANCEIRA]: 'Produção Financeira',
    [AreaEnum.FINANCEIRO]: 'Financeiro',
    [AreaEnum.CONTROLADORIA]: 'Controladoria',
    [AreaEnum.PRODUCAO]: 'Produção',
    [AreaEnum.PRODUCAO_GRAFICA]: 'Produção Gráfica',
};
export const AreaDescriptionMap = {
    [AreaEnum.ATENDIMENTO]: 'Responsável por gerenciar o relacionamento com os clientes, entender suas necessidades e garantir a satisfação.',
    [AreaEnum.TECNOLOGIA]: 'Responsável por desenvolver, implementar e manter soluções tecnológicas que atendam às necessidades da empresa.',
    [AreaEnum.PRE_PRODUCAO]: 'Responsável por planejar e organizar as etapas iniciais de um projeto, garantindo que tudo esteja pronto para a produção.',
    [AreaEnum.COMPRAS]: 'Responsável por adquirir bens e serviços necessários para a operação da empresa, negociando com fornecedores e garantindo a qualidade.',
    [AreaEnum.CRIACAO]: 'Responsável por criar e desenvolver conteúdos, campanhas ou produtos que atendam às necessidades do mercado e dos clientes.',
    [AreaEnum.PLANEJAMENTO]: 'Responsável por definir estratégias, metas e ações para alcançar os objetivos da empresa, garantindo a eficiência e o sucesso dos projetos.',
    [AreaEnum.PRODUCAO_FINANCEIRA]: 'Responsável por gerenciar os processos financeiros relacionados à produção, garantindo a eficiência e a rentabilidade.',
    [AreaEnum.FINANCEIRO]: 'Responsável por gerenciar as finanças da empresa, incluindo orçamento, contabilidade, análise financeira e planejamento.',
    [AreaEnum.CONTROLADORIA]: 'Responsável por monitorar e controlar os processos financeiros e operacionais da empresa, garantindo a conformidade e a eficiência.',
    [AreaEnum.PRODUCAO]: 'Responsável por coordenar e supervisionar as atividades de produção, garantindo a qualidade e a eficiência dos processos.',
    [AreaEnum.PRODUCAO_GRAFICA]: 'Responsável por coordenar e supervisionar as atividades de produção gráfica, garantindo a qualidade e a eficiência dos processos relacionados à impressão e design gráfico.',
};
